export default {
    TAGS_ARRAY: [
      { value: "", text: "" },
      { value: "Хит", text: "Хит" },
      { value: "Акция", text: "Акция" }, 
    ],
}